/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMemberRoleByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMemberRoleById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMemberRoleByIdIdRegExpTwo)]).optional()
});

export type GetMemberRoleById = zod.input<typeof GetMemberRoleById>;
export type GetMemberRoleByIdOutput = zod.output<typeof GetMemberRoleById>;
